import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { supabase, rpc } from './supabase.js';

// Auth = Supabase Auth (อีเมล+รหัสผ่าน) + โปรไฟล์ rent.staff (โหลดผ่าน rp_bootstrap)
// ระบบไม่เก็บ/ไม่แสดงรหัสผ่าน — ตั้งรหัสผ่านผ่านลิงก์อีเมลเท่านั้น
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(undefined);   // undefined = กำลังโหลด
  const [boot, setBoot] = useState(null);              // { me, perms, settings, tiers, ... }
  const [bootErr, setBootErr] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session ?? null));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => sub.subscription.unsubscribe();
  }, []);

  const reloadBoot = useCallback(async () => {
    if (!session?.user) { setBoot(null); return; }
    try {
      setBootErr(null);
      const b = await rpc('rp_bootstrap');
      setBoot(b);
    } catch (e) { setBootErr(e.message); }
  }, [session?.user?.id]);

  useEffect(() => { reloadBoot(); }, [reloadBoot]);

  const signIn = (email, password) => supabase.auth.signInWithPassword({ email, password });
  const signOut = () => supabase.auth.signOut();

  const me = boot?.me ?? null;
  const can = useCallback((perm) => !!(boot?.perms?.[perm]), [boot]);

  return (
    <AuthCtx.Provider value={{
      session, me, boot, bootErr, reloadBoot, signIn, signOut, can,
      settings: boot?.settings ?? {},
      tiers: boot?.tiers ?? [],
      volumeDiscounts: boot?.volume_discounts ?? [],
      tradeinGrades: boot?.tradein_grades ?? [],
      vatRate: Number(boot?.vat_rate ?? 0.07),
      whtRate: Number(boot?.wht_rate ?? 0.05),
    }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
